import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Pswd, User } from 'src/app/model';
import { AuthenticationRequest } from 'src/app/model/auth';
import { AuthProvider, UserProvider } from 'src/app/providers';
import { UserService, CommonService, ToasterService } from 'src/app/services';

declare var grecaptcha: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  @ViewChild('loginForm') loginForm: any;
  email: string = '';
  password: string = '';
  authCode: string = '';
  returnUrl: string = '';
  error: string = '';
  errorEmail: string = '';
  captchaVisible: boolean = false;
  // windowObj: any;

  new_pswd: string = '';
  conf_pswd: string = '';
  isForceChangePassword: boolean = false;
  forgotBlink: boolean = false;

  constructor(
    private authProvider: AuthProvider,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private toastr: ToasterService,
    public commonService: CommonService,
    private userProvider: UserProvider
  ) { }

  ngOnInit(): void {
    window.scrollTo(0,0);
    localStorage.removeItem('IV-TOKEN');
    localStorage.removeItem('IV-PROFILE');

    setInterval(() => {
      this.toastr.closeConnectionToastr();
    }, 50);

    this.returnUrl = this.route.snapshot.queryParams.url || '/';
  }

  /**
   * @description Submit user's credencials
   */
  submit(): void {
    localStorage.removeItem('IV-TOKEN');
    localStorage.removeItem('IV-PROFILE');
    if (this.loginForm.valid) {
      this.error = '';
      this.forgotBlink = false;
      let authReq = new AuthenticationRequest();
      authReq.email = this.email;
      authReq.password = this.password;
      if (this.captchaVisible) {
        authReq.captcha = grecaptcha.getResponse();
      }

      this.authProvider.authenticate(authReq).subscribe(response => {
        if (response.success) {
          if (response.result.token) {
            const userObj = User.parse(response.result.profile);
            localStorage.setItem('IV-TOKEN', response.result.token);
            this.userService.setUser(User.parse(response.result.profile));
            if (userObj.FORCE_PASS_RESET) {
              this.isForceChangePassword = true;
            } else {
              setTimeout(() => {
                this.router.navigateByUrl(decodeURI(this.returnUrl));
              }, 10);
            }
          }
        } else {
          this.captchaVisible = response.captcha;
          this.error = response.error.txt;
          this.errorEmail = this.email;
          if (this.error === 'Registration incomplete. Please click forgot password.') {
            this.forgotBlink = true;
          }
          if (this.captchaVisible) {
            grecaptcha.reset();
          }
        }
      }, err => {
        this.toastr.error('System in Maintenance Mode, please try again later.');
      });
    } else {
      this.toastr.error('Please enter valid fields!');
    }
  }

  public resolved(captchaResponse: string): void {
    // blank
  }

  /**
   * @description Remove error message
   */
  removeErrorMsg(): void{
    if(this.error && this.errorEmail !== this.email){
      this.error = '';
    }
  }

  /**
   * @description call update password
   */
   updatePassword() {
    let pswd = new Pswd();
    pswd.OLD_PASSWORD = this.password;
    pswd.NEW_PASSWORD = this.new_pswd;
    this.userProvider.changePassword(pswd).subscribe(resp => {
      if (resp.success) {
        this.toastr.success('Password change successfully!');
        setTimeout(() => {
          this.router.navigateByUrl(decodeURI(this.returnUrl));
        }, 10);
      } else {
        this.toastr.error(resp.error.txt);
      }
    }, err => {
      // Error Handling
    })
  }


}
